import logo from '../assets/logo_1.png';

const Logo: React.FC = () => {
  return (
    <div className="flex items-center space-x-2">
      <img src={logo} alt="Logo" width={200} height={20} />
    </div>
  );
};

export default Logo;